export default __webpack_public_path__ + "static/media/about.1d62e357.jpg";